export default "__VITE_ASSET__61e11ac0__"